import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { Action } from 'redux';


@Injectable()
export class SwishActions {
    static SET_TRANSACTION_DATA = '[Swish]: Set transaction data';
    static SET_TRANSACTION_DATA_EPIC = '[Swish]: Set transaction data w/ epic';
    static CLEAR_TRANSACTION_DATA = '[Swish]: Clear transaction data';

    static SET_TRANSACTION_STATUS = '[Swish]: Set transaction status';

    static SET_ACCOUNT_ID = '[Swish]: Set account id';
    static START_TRANSACTION = '[Swish]: Start transaction';
    static START_TRANSACTION_FAILED = '[Swish]: Start transaction failed';

    setTransactionData( payload: any ): RidangoReduxAction {
        return {
            type: SwishActions.SET_TRANSACTION_DATA,
            payload: payload
        };
    }
    setTransactionDataWithEpic(payload: any): RidangoReduxAction {
        return {
            type: SwishActions.SET_TRANSACTION_DATA_EPIC,
            payload: payload
        };
    }
    clearTransactionData(): RidangoReduxAction {
        return {
            type: SwishActions.CLEAR_TRANSACTION_DATA
        };
    }

    setTransactionStatus( payload: any ): RidangoReduxAction {
        return {
            type: SwishActions.SET_TRANSACTION_STATUS,
            payload: payload
        };
    }

    setAccountId( payload: any ): RidangoReduxAction {
        return {
            type: SwishActions.SET_ACCOUNT_ID,
            payload: payload
        };
    }

    startTransaction(payload): RidangoReduxAction {
        return {
            type: SwishActions.START_TRANSACTION,
            payload: payload
        };
    }

    startTransactionFailed(error): RidangoReduxAction {
        return {
            type: SwishActions.START_TRANSACTION_FAILED,
            payload: error
        };
    }

}
